import { useMutation } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'

import { mfaServices } from '../mfaServices'
import { MFAChallengeVerifyDTO, MFAChallengeVerifyPayload } from '../mfaTypes'

import { ApiErrorCode, ErrorDetail, IOptionsUseMutation } from '@/api/apiTypes'
import { mapAxiosErrorToApiError } from '@/utils'

export function useMFACodeVerification(
  options?: IOptionsUseMutation<MFAChallengeVerifyDTO>,
) {
  const { t } = useTranslation()

  const mutation = useMutation<
    MFAChallengeVerifyDTO,
    ErrorDetail,
    MFAChallengeVerifyPayload
  >({
    mutationFn: (data) => mfaServices.verifyMfa(data),
    onSuccess: (data) => {
      if (options?.onSuccess) {
        options.onSuccess(data)
      }
    },
    onError: (err) => {
      const { code } = mapAxiosErrorToApiError(err)

      let errorMessage = t('api:errors.somethingWrong')

      if (code === ApiErrorCode.TOO_MANY_ATTEMPTS) {
        errorMessage = t('api:errors.manyAttempts')
      }

      if (code === ApiErrorCode.MFA_NOT_VERIFIED) {
        errorMessage = t('api:validationErrors.invalidCode')
      }

      if (options?.onError) {
        options?.onError({ ...err, errorMessage, code })
      }
    },
  })

  return { ...mutation }
}
